import * as React from 'react';

import PropTypes from 'prop-types';

import SettingsActionCreators from 'bundles/account-settings/actions/SettingsActionCreators';
import DisableTwoFactorAuthentication from 'bundles/account-settings/components/sections/two-factor/DisableTwoFactorAuthentication';
import EnableTwoFactorAuthentication from 'bundles/account-settings/components/sections/two-factor/EnableTwoFactorAuthentication';
import TwoFactorAuthenticationModal from 'bundles/account-settings/components/sections/two-factor/TwoFactorAuthenticationModal';
import SettingsConstants from 'bundles/account-settings/constants/SettingsConstants';
import TwoFactorAuthenticationUtils from 'bundles/account-settings/utils/TwoFactorAuthenticationUtils';

import _t from 'i18n!nls/account-settings';

import 'css!./__styles__/Settings';

const { TwoFactorAuthenticationStatus } = SettingsConstants;

export default class Settings extends React.Component {
  static propTypes = {
    available: PropTypes.bool.isRequired,
    state: PropTypes.string.isRequired,
    qrCode: PropTypes.string,
    invalidFields: PropTypes.array.isRequired,
    updating: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'available' does not exist on type 'Reado... Remove this comment to see the full error message
    if (this.props.available) {
      SettingsActionCreators.loadTwoFactorAuthenticationSettings();
    }
  }

  isEnabled() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type 'Readonly<... Remove this comment to see the full error message
    return TwoFactorAuthenticationUtils.isEnabled(this.props.state);
  }

  isDisabled() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type 'Readonly<... Remove this comment to see the full error message
    return TwoFactorAuthenticationUtils.isDisabled(this.props.state);
  }

  isLoading() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type 'Readonly<... Remove this comment to see the full error message
    return this.props.state === TwoFactorAuthenticationStatus.LOADING;
  }

  renderBody() {
    if (this.isEnabled()) {
      return <DisableTwoFactorAuthentication />;
    } else if (this.isDisabled()) {
      return <EnableTwoFactorAuthentication />;
    } else {
      return <span>{_t('Loading')}</span>;
    }
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'available' does not exist on type 'Reado... Remove this comment to see the full error message
    if (this.props.available) {
      return (
        <div className="rc-TwoFactorAuthentication">
          <h2 className="display-2-text section-title">{_t('Two Factor Authentication (BETA)')}</h2>
          {this.renderBody()}
          <TwoFactorAuthenticationModal
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'state' does not exist on type 'Readonly<... Remove this comment to see the full error message
            state={this.props.state}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'qrCode' does not exist on type 'Readonly... Remove this comment to see the full error message
            qrCode={this.props.qrCode}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'invalidFields' does not exist on type 'R... Remove this comment to see the full error message
            invalidFields={this.props.invalidFields}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'updating' does not exist on type 'Readon... Remove this comment to see the full error message
            updating={this.props.updating}
          />
        </div>
      );
    } else {
      return <span />;
    }
  }
}
